<template>
  <!-- 最近订单 -->
  <div class="recentorder">

    <el-table class="eltabletl" border :data="tableData" style="width: 70%">
      <el-table-column prop="customName" label="客户名称">
        <template slot-scope="scope">
          <el-input v-model="scope.row.customName"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="proName" label="订货产品">
        <template slot-scope="scope">
          <el-input v-model="scope.row.proName"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="proNum" label="订货数量">
        <template slot-scope="scope">
          <el-input  v-model="scope.row.proNum"  type="number" oninput="if(value.length > 8) value=value.slice(0, 8)"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="payTime" label="应交付日期">
        <template slot-scope="scope">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="scope.row.payTime"  type="date" placeholder="选择日期"> </el-date-picker>

        </template>
      </el-table-column>
      <el-table-column prop="proSpeed" label="生产进度">
        <template slot-scope="scope">
          <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value > 100) value=100" v-model="scope.row.proSpeed">
            <template slot="suffix">%</template>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column width="80" fixed="right" label="操作">
        <template slot="header">
  
  
            <i @click="addRow" style="font-size: 1.2rem;font-weight: 600;cursor:pointer;position: relative;top: 0.1rem;color: #00ffff;" class="el-icon-circle-plus-outline"></i>

        </template>
        <template slot-scope="scope">
          <i @click="del(scope.row, scope.$index) " class="el-icon-remove-outline" style="font-size: 1.2rem;line-height: 1.8rem;color: #f00;font-weight: 600;cursor: pointer;"></i>

        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 2rem">
      <el-button @click="save" size="small" type="primary save">保存设置</el-button>
    </div>    
  </div>
</template>

<script>
import api from '@/apis/produce/recentorder'
export default {
  components: {},
  data() {
    return {
      tableData: [

      ],
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    addRow() {
      this.tableData.push({
        customName: '',//客户名称
        proName: '',//订货产品
        proNum: '',//订货数量
        payTime: '',//应交付日期
        proSpeed: '',//生产进度

      })
    },
    getlist() {
      api
        .list({
          params: {
            limit: 100,
            page: 1,
          },
        })
        .then((res) => {
          if (res.code === 10000) {
            // if (res.data.list.length) {
              this.tableData = res.data.list
            // }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    save() {
      api.save(this.tableData).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
          this.getlist()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    del(item, i) {
      this.$confirm(`确定删除数据？`).then(() => {
        if (item.id) {
          for (const iterator of this.tableData) {
            if (iterator.id === undefined) {
              return this.$message.warning(
                '还有未保存的数据,请先保存后再删除！'
              )
            }
          }

          api.del([item.id]).then((res) => {
            if (res.code === 10000) {
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
            this.getlist()
          })
        } else {
          this.tableData.splice(i, 1)
        }
      })
    },    
  },
}
</script>

<style lang="less">
.recentorder { padding-top:10px;
  .el-table__body{
    .el-date-editor{ width: 100%;}
    .el-input__inner{ border: none; width: 100%;}
  }
}
</style>